import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import {
  NotificationContentBase,
  NotificationItemBaseProps,
} from "../../types/notification.types";
import { ComponentNotificationTaskType } from "./types/task-notification.types";
import styles from "./task-notification.module.css";
import { TaskNotificationTitle } from "./TaskNotificationTitle";
import { TaskNotificationBody } from "./TaskNotificationBody";
import { TaskNotificationFooter } from "./TaskNotificationFooter";
import { useLocation, useSearchParams } from "react-router";

interface NotificationTaskNotificationFactoryProps extends NotificationItemBaseProps {
  content: NotificationContentBase;
}

export const NotificationTaskNotificationFactory = ({
  content,
  onClick,
  read,
  createdAt,
}: NotificationTaskNotificationFactoryProps) => {
  const {
    components,
    props: { taskId, changeType },
  } = content as ComponentNotificationTaskType;

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const newParams = new URLSearchParams(searchParams);
  newParams.set("taskViewer", String(taskId));
  const v2Url = `${location.pathname}?${newParams.toString()}`;

  // V2 uses big number as task id and V1 UUID
  const navigateUrl = isNaN(Number(taskId))
    ? `tasks?taskDetails=${taskId}`
    : v2Url;
  const [title, body, footer] = components;
  return (
    <div
      className={styles["task-notification-item"] ?? ""}
      onClick={() => onClick()}
      data-testid={changeType}
    >
      <FixaLink to={navigateUrl}>
        <TaskNotificationTitle component={title} read={read} />
        <TaskNotificationBody component={body} read={read} />
        <TaskNotificationFooter component={footer} createdAt={createdAt} />
      </FixaLink>
    </div>
  );
};
